import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useGetBlogByIdQuery } from '../blogsApiSlice';
import EditBlogForm from './EditBlogForm';

export default function EditBlog() {
  const { id } = useParams(); // when creating, id will be undefined
  const navigate = useNavigate();

  const {
    data: blogData,
    isLoading: loadingBlog,
    isError,
    error,
  } = useGetBlogByIdQuery(id, {
    skip: !id,
  });

  // get actual blog entity (getBlogById transform returns { ids: [...], entities: { id: blog } })
  const initial = React.useMemo(() => {
    if (!blogData) return {};
    const firstId = blogData.ids?.[0];
    return (blogData.entities && firstId && blogData.entities[firstId]) || {};
  }, [blogData]);

  const handleSaved = (saved) => {
    // after create/update navigate back to admin list or to edit saved item
    if (saved?.id) {
      navigate('/dash/blogs');
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">{id ? 'Edit Blog' : 'Create Blog'}</h1>
          <p className="text-gray-600">{id ? 'Update the blog post' : 'Create a new blog post'}</p>
        </div>

        <div className="flex items-center gap-3">
          <Link to="/dash/blogs" className="rounded-xl border px-4 py-2 text-gray-700 hover:bg-gray-50">
            Back to list
          </Link>
        </div>
      </div>

      {isError ? (
        <div className="rounded-md border border-red-200 bg-red-50 p-4 text-red-700">
          Error loading blog: {error?.data?.message ?? error?.status ?? 'Unknown'}
        </div>
      ) : loadingBlog ? (
        <div className="text-gray-500">Loading…</div>
      ) : (
        <EditBlogForm
          id={id}
          initial={initial}
          onSaved={handleSaved}
          onCancel={() => navigate(-1)}
        />
      )}
    </div>
  );
}
